import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Exeter Flow Screeds" },
      {
        name: "description",
        content:
          "Privacy Policy for Exeter Flow Screeds Ltd. Learn how we collect, store, and protect your personal information under UK GDPR.",
      },
      { property: "og:title", content: "Privacy Policy | Exeter Flow Screeds" },
      {
        property: "og:description",
        content:
          "Privacy Policy for Exeter Flow Screeds Ltd. Learn how we collect, store, and protect your personal information under UK GDPR.",
      },
      {
        property: "og:url",
        content: "https://exeterflowscreed.co.uk/privacy-policy",
      },
      {
        name: "twitter:title",
        content: "Privacy Policy | Exeter Flow Screeds",
      },
      {
        name: "twitter:description",
        content:
          "Privacy Policy for Exeter Flow Screeds Ltd. Learn how we collect, store, and protect your personal information under UK GDPR.",
      },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://exeterflowscreed.co.uk/privacy-policy",
      },
    ],
  }),
  component: PrivacyPolicy,
});
